import { render, staticRenderFns } from "./ProfileShow.vue?vue&type=template&id=0ae53e32&scoped=true&"
import script from "./ProfileShow.vue?vue&type=script&lang=js&"
export * from "./ProfileShow.vue?vue&type=script&lang=js&"
import style0 from "./ProfileShow.vue?vue&type=style&index=0&id=0ae53e32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae53e32",
  null
  
)

export default component.exports